import Logger from './';
import creator from './kycreator';
export default new Logger({
    radarId: '419b038523',
}, creator);
